import Burger from './svg/burger.svg?react';

export const StyledBurger = Burger;
